// src/components/FilterPanel.js
import React from "react";

const PRACTICES = ["Data & AI", "Cloud & Digital", "TL&M"];
const SOLUTION_TYPES = ["BootCamp", "Deep Skilling", "Transformative", "Practice Overview"];
const SALES_READY = [
  { value: "coverEmail",         label: "Cover Email" },
  { value: "productNote",        label: "Product Note" },
  { value: "successStory",       label: "Success Story" },
  { value: "discoveryQuestions", label: "Discovery Questions" },
];

const SOLUTION_COLORS = {
  "BootCamp":      "pill--bootcamp",
  "Deep Skilling": "pill--deepskilling",
  "Transformative":"pill--transformative",
  "Practice Overview":       "pill--overall",
};

const PRACTICE_COLORS = {
  "Data & AI":       "pill--teal",
  "Cloud & Digital": "pill--green",
  "TL&M":            "pill--purple",
};

function TogglePill({ label, active, onClick, colorClass = "" }) {
  return (
    <button
      className={`filter-pill ${colorClass} ${active ? "filter-pill--active" : ""}`}
      onClick={() => onClick(label)}
      aria-pressed={active}
    >
      {active && <span aria-hidden="true" className="pill-check">✓</span>}
      {label}
    </button>
  );
}

export function FilterPanel({
  selectedPractices,    onTogglePractice,
  selectedSolutionTypes, onToggleSolutionType,
  selectedSalesReady,   onToggleSalesReady,
  searchKeyword, onSearchChange, onSearch, onReset,
}) {
  const handleKeyDown = (e) => {
    if (e.key === "Enter") onSearch();
  };

  return (
    <section className="filter-panel" aria-label="Filters and search">
      <h2 className="filter-heading">FILTERS &amp; SEARCH</h2>

      <div className="filter-row">
        <div className="filter-group">
          <span className="filter-group-label">PRACTICE</span>
          <div className="pill-group">
            {PRACTICES.map((p) => (
              <TogglePill
                key={p}
                label={p}
                active={selectedPractices.includes(p)}
                onClick={onTogglePractice}
                colorClass={PRACTICE_COLORS[p]}
              />
            ))}
          </div>
        </div>

        <div className="filter-group">
          <span className="filter-group-label">SOLUTION TYPE</span>
          <div className="pill-group">
            {SOLUTION_TYPES.map((s) => (
              <TogglePill
                key={s}
                label={s}
                active={selectedSolutionTypes.includes(s)}
                onClick={onToggleSolutionType}
                colorClass={SOLUTION_COLORS[s]}
              />
            ))}
          </div>
        </div>

        <div className="filter-group filter-group--search">
          <span className="filter-group-label">KEYWORD SEARCH</span>
          <div className="search-row">
            <div className="search-input-wrap">
              <svg className="search-icon" width="16" height="16" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                <circle cx="11" cy="11" r="8" /><path d="m21 21-4.35-4.35" />
              </svg>
              <input
                type="text"
                className="search-input"
                placeholder="e.g. Project Management"
                value={searchKeyword}
                onChange={(e) => onSearchChange(e.target.value)}
                onKeyDown={handleKeyDown}
                aria-label="Keyword search"
              />
            </div>
            <button className="btn-search" onClick={onSearch}>Search</button>
            <button className="btn-reset" onClick={onReset}>Reset</button>
          </div>
        </div>
      </div>

      <div className="sales-ready-row">
        <div className="sales-ready-label">
          <span className="sales-ready-text">SALES READY — SHOW ONLY COURSES WITH:</span>
        </div>
        <div className="pill-group">
          {SALES_READY.map(({ value, label }) => (
            <button
              key={value}
              className={`filter-pill sales-pill ${selectedSalesReady.includes(value) ? "filter-pill--active" : ""}`}
              onClick={() => onToggleSalesReady(value)}
              aria-pressed={selectedSalesReady.includes(value)}
            >
              {selectedSalesReady.includes(value) && <span aria-hidden="true" className="pill-check">✓</span>}
              {label}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
